// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'A sua loja num telemóvel',
    desktop: 'A sua loja num computador',
  },
  loading: 'A carregar a captura de ecrã',
  failed: 'Não foi possível carregar a captura de ecrã.',
};
